<template>
  <div>
    <div class="switcher-container px-4">
      <div
        @click="
          makeCurrent({
            name: 'comply-advantage-index',
            params: { short: home ? 'short' : null },
          })
        "
        class="main-service-switcher"
        :class="currentLink == 'comply-advantage-index' ? 'active' : ''"
      >
        <div class="icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.5858 5L13.3263 10.2595L9.48566 8.12584C9.07032 7.8951 8.54997 7.98846 8.24076 8.34921L2.24076 15.3492C1.88134 15.7685 1.9299 16.3998 2.34923 16.7593C2.76855 17.1187 3.39985 17.0701 3.75927 16.6508L9.228 10.2706L13.0144 12.3742C13.4047 12.591 13.8914 12.5228 14.2071 12.2071L20 6.41421V8C20 8.55228 20.4477 9 21 9C21.5523 9 22 8.55228 22 8V4C22 3.86441 21.973 3.73512 21.9241 3.61722C21.8753 3.49927 21.803 3.38877 21.7071 3.29289C21.6112 3.19702 21.5007 3.12468 21.3828 3.07588C21.2649 3.02699 21.1356 3 21 3H20.9998H17C16.4477 3 16 3.44772 16 4C16 4.55228 16.4477 5 17 5H18.5858ZM18 17C18 17.5523 18.4477 18 19 18C19.5523 18 20 17.5523 20 17V13C20 12.4477 19.5523 12 19 12C18.4477 12 18 12.4477 18 13V17ZM10 18C9.44773 18 9.00002 17.5523 9.00002 17V15C9.00002 14.4477 9.44773 14 10 14C10.5523 14 11 14.4477 11 15V17C11 17.5523 10.5523 18 10 18ZM2.00002 21C2.00002 20.4477 2.44773 20 3.00002 20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3.00002C2.44773 22 2.00002 21.5523 2.00002 21Z"
              fill="#FE5000"
            />
          </svg>
        </div>
        <div class="title text-center">
          {{ $t("message.menu.monitoring") }}
        </div>
      </div>
      <div
        @click="
          makeCurrent({
            name: 'find-partner-410',
            params: {
              short: home ? 'short' : null,
              services: ['410'],
              prices: {},
              currency: {},
            },
          })
        "
        class="main-service-switcher"
        :class="currentLink == 'find-partner-410' ? 'active' : ''"
      >
        <div class="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              fill="#e9521d"
              d="M14.33,12.9l5.38,5.38c.19,.19,.3,.45,.3,.71,0,.27-.11,.52-.3,.71-.19,.19-.45,.3-.71,.3-.27,0-.52-.11-.71-.3l-5.38-5.38c-1.61,1.25-3.63,1.83-5.66,1.64-2.03-.19-3.9-1.15-5.25-2.68C.65,11.76-.06,9.78,0,7.75,.07,5.71,.9,3.78,2.34,2.34,3.78,.9,5.71,.07,7.75,0c2.03-.06,4.01,.65,5.54,1.99,1.53,1.34,2.48,3.22,2.68,5.25,.19,2.03-.39,4.05-1.64,5.66h0Zm-6.33,1.1c1.59,0,3.12-.63,4.24-1.76s1.76-2.65,1.76-4.24-.63-3.12-1.76-4.24c-1.13-1.13-2.65-1.76-4.24-1.76s-3.12,.63-4.24,1.76-1.76,2.65-1.76,4.24,.63,3.12,1.76,4.24c1.13,1.13,2.65,1.76,4.24,1.76Z"
            />
            <path
              fill="#e9521d"
              d="M17.63,9.3h2.3v-2.39h1.4v2.39h2.32v1.32h-2.32v2.41h-1.4v-2.41h-2.3v-1.32Z"
            />
          </svg>
        </div>
        <div class="title text-center">
          {{ $t("message.menu.find_partner_410") }}
        </div>
      </div>
      <div
        @click="
          makeCurrent({
            name: 'find-partner-info',
            params: {
              short: home ? 'short' : null,
              services: ['886'],
              prices: {},
              currency: {},
            },
          })
        "
        class="main-service-switcher"
        :class="currentLink == 'find-partner-info' ? 'active' : ''"
      >
        <div class="icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.3248 14.8992L21.7048 20.2792C21.8939 20.4685 22 20.7251 22 20.9926C21.9999 21.2601 21.8935 21.5166 21.7043 21.7057C21.515 21.8948 21.2584 22.001 20.9909 22.0009C20.7234 22.0008 20.4669 21.8945 20.2778 21.7052L14.8978 16.3252C13.2895 17.5709 11.267 18.1571 9.24189 17.9646C7.21674 17.7721 5.341 16.8153 3.99625 15.2888C2.6515 13.7624 1.93876 11.781 2.00302 9.74778C2.06728 7.71451 2.90372 5.78209 4.34217 4.34364C5.78063 2.90518 7.71305 2.06875 9.74631 2.00448C11.7796 1.94022 13.761 2.65296 15.2874 3.99771C16.8138 5.34246 17.7706 7.21821 17.9631 9.24336C18.1556 11.2685 17.5694 13.2909 16.3238 14.8992H16.3248ZM9.99977 16.0002C11.5911 16.0002 13.1172 15.3681 14.2424 14.2429C15.3676 13.1177 15.9998 11.5915 15.9998 10.0002C15.9998 8.40893 15.3676 6.88281 14.2424 5.75759C13.1172 4.63237 11.5911 4.00023 9.99977 4.00023C8.40847 4.00023 6.88235 4.63237 5.75713 5.75759C4.63191 6.88281 3.99977 8.40893 3.99977 10.0002C3.99977 11.5915 4.63191 13.1177 5.75713 14.2429C6.88235 15.3681 8.40847 16.0002 9.99977 16.0002Z"
              fill="#FE5000"
            />
          </svg>
        </div>
        <div class="title text-center">
          {{ $t("message.menu.find_partner") }}
        </div>
      </div>
      <div
        @click="
          makeCurrent({
            name: 'business-note',
            params: {
              short: home ? 'short' : null,
              services: ['430', '930', '701', '213', '736'],
              prices: {},
              currency: {},
            },
          })
        "
        class="main-service-switcher"
        :class="currentLink == 'business-note' ? 'active' : ''"
      >
        <div class="icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10 2C9.44772 2 9 2.44772 9 3V5H3C2.44772 5 2 5.44772 2 6V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V3C22 2.44772 21.5523 2 21 2H10ZM4 7H9V16C9 16.5523 8.55228 17 8 17H7C6.44772 17 6 17.4477 6 18C6 18.5523 6.44772 19 7 19H8C9.65685 19 11 17.6569 11 16V6V4H20V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7ZM13 6C12.4477 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8H18C18.5523 8 19 7.55228 19 7C19 6.44772 18.5523 6 18 6H13ZM12 11C12 10.4477 12.4477 10 13 10H18C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12H13C12.4477 12 12 11.5523 12 11ZM13 14C12.4477 14 12 14.4477 12 15C12 15.5523 12.4477 16 13 16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H13Z"
              fill="#FE5000"
            />
          </svg>
        </div>
        <div class="title text-center">
          {{ $t("message.menu.business_note") }}
        </div>
      </div>
    </div>
    <div class="search-block px-4">
      <div class="icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.6041 12.4159L18.0875 16.8993C18.2451 17.057 18.3335 17.2708 18.3335 17.4937C18.3334 17.7167 18.2447 17.9304 18.0871 18.088C17.9294 18.2456 17.7155 18.3341 17.4926 18.334C17.2697 18.3339 17.0559 18.2453 16.8983 18.0876L12.415 13.6043C11.0747 14.6423 9.38937 15.1308 7.70174 14.9704C6.01412 14.81 4.451 14.0126 3.33037 12.7406C2.20975 11.4686 1.61579 9.81746 1.66935 8.12307C1.7229 6.42868 2.41993 4.81833 3.61864 3.61962C4.81735 2.4209 6.4277 1.72387 8.12209 1.67032C9.81648 1.61677 11.4676 2.21072 12.7396 3.33135C14.0117 4.45197 14.809 6.01509 14.9694 7.70272C15.1299 9.39034 14.6414 11.0757 13.6033 12.4159H13.6041ZM8.3333 13.3334C9.65938 13.3334 10.9312 12.8067 11.8688 11.869C12.8065 10.9313 13.3333 9.65953 13.3333 8.33345C13.3333 7.00736 12.8065 5.73559 11.8688 4.79791C10.9312 3.86023 9.65938 3.33345 8.3333 3.33345C7.00722 3.33345 5.73545 3.86023 4.79777 4.79791C3.86009 5.73559 3.3333 7.00736 3.3333 8.33345C3.3333 9.65953 3.86009 10.9313 4.79777 11.869C5.73545 12.8067 7.00722 13.3334 8.3333 13.3334Z"
            fill="#8D8D8D"
          />
        </svg>
      </div>
      <input
        type="text"
        v-model="search"
        class="main-search"
        :placeholder="placeholder"
      />
      <button class="search-button" @click="doSearch">
        {{ $t("message.find") }}
      </button>
    </div>
    <div v-if="currentLink == 'comply-advantage-index'" class="px-4">
      <div class="mt-3">
        <button
          class="pl-0 btn btn-link text-button"
          @click="toggleShowSearchParams"
          v-if="!show_search_params"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289Z"
              fill="#797980"
            /></svg
          >{{ $t("message.comply_advantage.show_additional_params") }}
        </button>
        <button
          class="pl-0 btn btn-link text-button"
          @click="toggleShowSearchParams"
          v-if="show_search_params"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L11.2929 8.29289C11.6834 7.90237 12.3166 7.90237 12.7071 8.29289L18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071L12 10.4142L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071Z"
              fill="#797980"
            /></svg
          >{{ $t("message.comply_advantage.hide_additional_params") }}
        </button>
      </div>
      <div class="additional_ca_options" v-if="show_search_params">
        <fieldset>
          <legend>
            {{ $t("message.comply_advantage.entity_type_title") }}
          </legend>
          <div class="radio-selector-w-icons">
            <label
              v-for="(row, rt) in entity_types"
              class="d-flex align-items-center flex-column justify-content-center"
              :key="rt"
            >
              <input
                type="radio"
                v-model="search_obj.entity"
                :value="row.value"
              />
              <span v-html="row.icon"></span>
              {{ row.display_text }}
            </label>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            {{ $t("message.comply_advantage.fuzziness_title") }}
          </legend>
          <div class="range-parent">
            <input
              type="range"
              v-model="fuzziness_connector"
              list="values"
              step="10"
            />
            <datalist id="values">
              <option
                v-for="typ in fuzzy_types"
                :value="typ.value"
                :label="typ.value + '%'"
              ></option>
            </datalist>
            <div class="range-comment">
              {{ search_obj.fuzziness.display_text }}
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <dashCaHistory v-if="currentLink == 'comply-advantage-index'" />
    <dashHistory v-else :type="currentLink" />
    <!-- <div class="px-4"><homeBanner /></div> -->
  </div>
</template>
<script>
// import homeBanner from "./home-banner.vue";
import dashCaHistory from "./dash-ca-history.vue";
import dashHistory from "./dash-history.vue";
export default {
  name: "MainServiceSwitcher",
  components: { dashCaHistory, dashHistory }, // homeBanner
  props: {
    home: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    saveSearchParams() {
      window.localStorage.setItem("cassp", this.show_search_params ? "1" : "0");
      window.localStorage.setItem("cafuz", this.fuzziness_connector);
      window.localStorage.setItem("caent", this.search_obj.entity);
    },
    loadSearchParams() {
      let show_search_params = window.localStorage.getItem("cassp");

      if (show_search_params == undefined) {
        show_search_params = false;
      }
      if (show_search_params == "0") show_search_params = false;
      if (show_search_params == "1") show_search_params = true;

      this.show_search_params = show_search_params;

      let fuzziness = window.localStorage.getItem("cafuz");
      if (fuzziness == undefined) fuzziness = 100;
      else fuzziness = parseInt(fuzziness);

      this.fuzziness_connector = fuzziness;

      let entity = window.localStorage.getItem("caent");
      if (entity == undefined) entity = 0;
      else entity = parseInt(entity);

      this.search_obj.entity = entity;
    },
    toggleShowSearchParams() {
      this.show_search_params = !this.show_search_params;
      this.saveSearchParams();
    },
    makeCurrent(data) {
      let { name } = data;
      this.details = data;
      this.currentLink = name;
    },
    doSearch() {
      if (this.currentLink == "comply-advantage-index") {
        this.$router.push({
          name: this.details.name,
          params: {
            services: this.details.services,
            prices: this.details.prices,
            search: this.search,
            entity: this.search_obj.entity,
            fuzziness: this.search_obj.fuzziness,
          },
        });
      } else {
        this.$router.push({
          name: this.details.name,
          params: {
            services: this.details.services,
            prices: this.details.prices,
            search: this.search,
          },
        });
      }
    },
  },
  mounted() {
    this.loadSearchParams();
  },
  computed: {
    placeholder() {
      switch (this.currentLink) {
        case "business-note":
          return this.$t("message.find_partner.bn_search_keyword_placeholder");
        case "find-partner-info":
          return this.$t("message.find_partner.search_keyword_placeholder");
        case "find-partner-410":
          return this.$t("message.find_partner.search_keyword_placeholder");
        case "comply-advantage-index":
          return this.$t("message.find_partner.ca_search_keyword_placeholder");
      }
    },
  },
  watch: {
    fuzziness_connector() {
      let el = this.fuzzy_types.find(
        (item) => item.value == this.fuzziness_connector,
      );
      this.search_obj.fuzziness = el;
    },
    search_obj: {
      deep: true,
      handler() {
        this.saveSearchParams();
      },
    },
  },
  data() {
    return {
      details: {
        name: "comply-advantage-index",
        prices: {},
        services: {},
      },
      search: "",
      search_obj: {
        entity: 0,
        fuzziness: {
          value: 100,
          display_text: this.$t("message.comply_advantage.fuzzy_100"),
        },
      },
      fuzziness_connector: 100,
      currentLink: "comply-advantage-index",
      show_search_params: false,

      entity_types: [
        {
          display_text: this.$t("message.comply_advantage.entity_type_all"),
          value: 0,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"/></svg>',
        },
        {
          display_text: this.$t("message.comply_advantage.entity_type_person"),
          value: 1,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/></svg>',
        },
        {
          display_text: this.$t("message.comply_advantage.entity_type_company"),
          value: 2,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"/></svg>',
        },
        {
          display_text: this.$t(
            "message.comply_advantage.entity_type_organisation",
          ),
          value: 3,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"/></svg>',
        },
        {
          display_text: this.$t("message.comply_advantage.entity_type_vessel"),
          value: 4,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"/></svg>',
        },
        {
          display_text: this.$t(
            "message.comply_advantage.entity_type_aircraft",
          ),
          value: 5,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"/></svg>',
        },
      ],
      fuzzy_types: [
        {
          display_text: this.$t("message.comply_advantage.fuzzy_exact"),
          value: 0,
        },
        // {display_text: this.$t('message.comply_advantage.fuzzy_0'), value: 0},
        {
          display_text: this.$t("message.comply_advantage.fuzzy_10"),
          value: 10,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_20"),
          value: 20,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_30"),
          value: 30,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_40"),
          value: 40,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_50"),
          value: 50,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_60"),
          value: 60,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_70"),
          value: 70,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_80"),
          value: 80,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_90"),
          value: 90,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_100"),
          value: 100,
        },
      ],
    };
  },
};
</script>
<style scoped>
.switcher-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.main-service-switcher {
  width: 23%;
  padding: 20px;

  /* primary100 */

  background: #ffffff;
  border-radius: 20px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  text-decoration: none !important;
}
.main-service-switcher.active {
  background: var(--color2);
  box-shadow:
    0px 30px 40px rgba(71, 178, 228, 0.5),
    0px 40px 60px rgba(71, 178, 228, 0.1);
}
.main-service-switcher .icon {
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: #f9fafa;
  margin: 0 auto 12px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-service-switcher.active .icon {
  background-color: #fff;
}
.main-service-switcher .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  letter-spacing: 0.25px;
  text-decoration: none !important;
  /* attis/primary */

  color: #04416d;
}
.main-service-switcher.active .title {
  color: #fff;
}
.search-block {
  margin-top: 60px;
  display: flex;
  position: relative;
  gap: 20px;
}
.search-block .icon {
  position: absolute;
  top: 13px;
  left: 40px;
}
.search-block input {
  flex-basis: 100%;
  box-shadow:
    0px 12px 32px rgba(0, 0, 0, 0.04),
    0px 8px 24px rgba(0, 0, 0, 0.04),
    0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.08);
  border-radius: 30px;
  padding: 14px 44px;
  border: 0;
}
.search-block button {
  padding: 14px 40px;
  background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%);
  border-radius: 30px;
  border: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* primary100 */

  color: #ffffff;
}
.additional_ca_options fieldset {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 12px;
  gap: 8px;

  /* neutral/50 */

  border: 1px solid #b1b1b1;
  border-radius: 4px;
}
.additional_ca_options fieldset legend {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
  width: auto;
  padding: 0 5px;
}
.additional_ca_options .radio-selector-w-icons {
  display: flex;
  width: 100%;
}
.additional_ca_options .radio-selector-w-icons label {
  width: 16%;
  flex-basis: 16%;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 10px;
  text-align: center;
  position: relative;
  padding: 15px 0;
  cursor: pointer;
}
.additional_ca_options .radio-selector-w-icons label input {
  position: absolute;
  opacity: 0;
}
.additional_ca_options .radio-selector-w-icons label span {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}
.additional_ca_options
  .radio-selector-w-icons
  label
  input:checked
  + span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border: 2px solid var(--color2);
  border-radius: 8px;
}
datalist {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  writing-mode: vertical-lr;
  width: 100%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
}
.range-parent {
  display: block;
  width: 100%;
}
.range-comment {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
  margin-top: 10px;
}
.range-parent input {
  width: 100%;
}

[type="range"] {
  --range: calc(var(--max) - var(--min));
  --ratio: calc((var(--val) - var(--min)) / var(--range));
  --sx: calc(0.5 * 1.5em + var(--ratio) * (100% - 1.5em));
  margin: 0;
  padding: 0;
  width: 12.5em;
  height: 1.5em;
  background: transparent;
  font:
    1em/1 arial,
    sans-serif;
}
[type="range"],
[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
[type="range"]::-webkit-slider-runnable-track {
  box-sizing: border-box;
  border: none;
  width: 12.5em;
  height: 0.25em;
  background: #ccc;
  border-radius: 4px;
}
.js [type="range"]::-webkit-slider-runnable-track {
  background: linear-gradient(#cfebf8, #cfebf8) 0 / var(--sx) 100% no-repeat
    #ccc;
}
[type="range"]::-moz-range-track {
  box-sizing: border-box;
  border: none;
  width: 12.5em;
  height: 0.25em;
  background: #ccc;
  border-radius: 4px;
}
[type="range"]::-ms-track {
  box-sizing: border-box;
  border: none;
  width: 12.5em;
  height: 0.25em;
  background: #ccc;
  border-radius: 4px;
}
[type="range"]::-moz-range-progress {
  height: 0.25em;
  background: #cfebf8;
}
[type="range"]::-ms-fill-lower {
  height: 0.25em;
  background: #cfebf8;
}
[type="range"]::-webkit-slider-thumb {
  margin-top: -0.625em;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: var(--color2);
}
[type="range"]::-moz-range-thumb {
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: var(--color2);
}
[type="range"]::-ms-thumb {
  margin-top: 0;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: var(--color2);
}
[type="range"]::-ms-tooltip {
  display: none;
}

.additional_ca_options {
  display: flex;
  gap: 20px;
}
.additional_ca_options fieldset {
  flex-basis: 50%;
}
</style>
<style>
.additional_ca_options .radio-selector-w-icons label span svg {
  width: 18px;
  height: 18px;
  display: block;
  fill: #b1b1b1;
}
.additional_ca_options .radio-selector-w-icons label input:checked + span svg {
  fill: var(--color2);
}
.togglebutton label .toggle::before {
  background: #b1b1b1;
  border: 0;
  height: 22px;
  width: 44px;
}

.togglebutton label .toggle::before {
  background: #b1b1b1 !important;
  border: 0 !important;
  height: 22px !important;
  width: 44px !important;
}
.togglebutton label .toggle::after {
  width: 18px !important;
  height: 18px !important;
  background-color: #fff !important;
  top: 2px !important;
  left: 2px !important;
}
.togglebutton label input:checked ~ .toggle::before {
  background: linear-gradient(90deg, #b1b1b1  0%, #b1b1b1 100%) !important;
}
.togglebutton label input:checked ~ .toggle::after {
  left: 24px !important;
  transform: unset !important;
}
</style>
